<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <span class="flex-grow-1" v-if="name"><b>{{ $t('memberIntro') }}</b> {{name}}</span>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <div class="d-flex flex-column">
                    <!-- Year -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('yearMandatory') }}</label>
                        <CInput type="text" v-model="prize.year" :invalid-feedback="errorOutput['Year']" :is-valid="genericValidator(prize.year) && errorValidator('Year')"></CInput>
                    </div>                        
                    <!-- Titles -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('titleMandatory') }}</label>
                        <VueEditor v-model="prize.titles[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(prize.titles) == false || errorValidator('Titles') }"></VueEditor>
                        <div v-if="errorOutput['Titles']" class="invalid-feedback">{{errorOutput['Titles']}}</div>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <div role="group" class="form-group col-12 d-flex justify-content-end">
                    <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                    <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                </div>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import Prize from "@/classes/Prize";
import { mapState, mapActions } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import { VueEditor } from "vue2-editor";

  export default {
  components: { LanguageDropdown, ConfirmationPopUp, FormLoading, VueEditor },
    props:{    
        basePrize:
        {
            type: Object,
            default: null,
        },
        basePrizeName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            triedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            prize: new Prize({}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetPrize();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate multilanguage fields
            for (const [key, value] of Object.entries(this.prize.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        ...mapState('prizes', ['postPrizeOutput']),
        ...mapState('prizes', ['putPrizeOutput']),
        name: function()
        {
            return this.basePrize || this.basePrizeName ? (this.basePrize ? this.basePrize.name : this.basePrizeName) : null;
        }
    },
    methods:{
        resetPrize(){
            if(!this.basePrize)
            {
                var titles = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; });

                this.prize = new Prize(titles);
            }
            else
            {
                this.prize = deepClone(new Prize, this.basePrize);          
            }
        },
        submitClicked(){
            this.triedSubmit = true;
            // Emit event
            if(this.prize.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.prize);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "PrizesList" });
        },
    },
    watch:
    {
        putPrizeOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        postPrizeOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        basePrize: function()
        {
            this.resetPrize();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

    .showDropdown
    {
        display: block !important;
    }

    .input-group-append
    {
      height: fit-content;
    }

    img
    {
        width: 50%;
        height: 50%;
    }

</style> 